import { render, staticRenderFns } from "./evaCard.vue?vue&type=template&id=82d4e620&scoped=true"
import script from "./evaCard.vue?vue&type=script&lang=js"
export * from "./evaCard.vue?vue&type=script&lang=js"
import style0 from "./evaCard.vue?vue&type=style&index=0&id=82d4e620&prod&lang=less&scoped=true"
import style1 from "./evaCard.vue?vue&type=style&index=1&id=82d4e620&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82d4e620",
  null
  
)

export default component.exports